
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/technology",
      function () {
        return require("private-next-pages/[locale]/technology.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/technology"])
      });
    }
  